var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 17.3766C10.7244 17.3766 11.3116 17.9639 11.3116 18.6883C11.3116 19.4127 10.7244 20 9.99993 20C9.2755 20 8.68823 19.4127 8.68823 18.6883C8.68823 17.9639 9.2755 17.3766 9.99993 17.3766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 -0.000351906C10.7244 -0.000351906 11.3116 0.586916 11.3116 1.31135C11.3116 2.03578 10.7244 2.62305 9.99993 2.62305C9.2755 2.62305 8.68823 2.03578 8.68823 1.31135C8.68823 0.586916 9.2755 -0.000351906 9.99993 -0.000351906Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65496 16.2291C6.37939 16.2291 6.96666 16.8164 6.96666 17.5408C6.96666 18.2653 6.37939 18.8525 5.65496 18.8525C4.93053 18.8525 4.34326 18.2653 4.34326 17.5408C4.34326 16.8164 4.93053 16.2291 5.65496 16.2291Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4938 3.1128C15.8457 2.49694 15.6257 1.70512 15.0099 1.3092C14.394 0.957282 13.6022 1.17723 13.2063 1.7931C12.8544 2.40896 13.0743 3.20078 13.6902 3.59669C14.306 3.94862 15.1419 3.72867 15.4938 3.1128Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12609 15.4812C3.74196 15.1306 3.96191 14.3417 3.60999 13.6843C3.25806 13.0707 2.46624 12.8515 1.80639 13.2021C1.19052 13.5528 0.970573 14.3417 1.3225 14.9991C1.67442 15.6565 2.51023 15.8319 3.12609 15.4812Z",
    fill: "#FCFDFF",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2054 6.79396C18.8213 6.44204 19.0413 5.65021 18.6893 4.99036C18.3374 4.3745 17.5456 4.15455 16.8857 4.50647C16.2699 4.85839 16.0499 5.65021 16.4018 6.31007C16.7538 6.92593 17.5456 7.14588 18.2054 6.79396Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3117 8.69008C2.03613 8.69008 2.6234 9.27735 2.6234 10.0018C2.6234 10.7262 2.03613 11.3135 1.3117 11.3135C0.587268 11.3135 0 10.7262 0 10.0018C0 9.27735 0.587268 8.69008 1.3117 8.69008Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6884 8.69008C19.4128 8.69008 20.0001 9.27735 20.0001 10.0018C20.0001 10.7262 19.4128 11.3135 18.6884 11.3135C17.964 11.3135 17.3767 10.7262 17.3767 10.0018C17.3767 9.27735 17.964 8.69008 18.6884 8.69008Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80558 6.79396C2.41689 7.14588 3.20286 6.92593 3.59585 6.31007C3.94517 5.6942 3.72684 4.90238 3.11553 4.50647C2.50422 4.15455 1.71825 4.3745 1.32527 4.99036C0.932283 5.60622 1.19427 6.39805 1.80558 6.79396Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8857 15.4834C17.5016 15.8353 18.2934 15.6154 18.6893 14.9995C19.0413 14.3837 18.8213 13.5918 18.2054 13.1959C17.5896 12.844 16.7978 13.064 16.4018 13.6798C16.0499 14.2957 16.2699 15.1315 16.8857 15.4834Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51805 3.1128C4.86997 3.72867 5.6618 3.94862 6.32165 3.59669C6.93751 3.24477 7.15746 2.45295 6.80554 1.7931C6.45362 1.17723 5.6618 0.957282 5.00194 1.3092C4.38608 1.70512 4.16613 2.49694 4.51805 3.1128Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2063 18.1939C13.5582 18.8097 14.35 19.0297 15.0099 18.6777C15.6257 18.3258 15.8457 17.534 15.4938 16.8742C15.1419 16.2583 14.35 16.0383 13.6902 16.3903C13.0743 16.7422 12.8544 17.534 13.2063 18.1939Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.d6b1a4275b25eeb3a8045ca519ef96ae.svg";
export { ForwardRef as ReactComponent };